/**
 * The "Partner offers" page for one trip (REQ-025), reached from the section
 * on the trip page. The same list, with the explanation of what it is.
 */
import { PartnerOfferList } from "@/components/marketplace/PartnerOfferList";
import { PageBanner } from "@/components/ui/PageBanner";
import {
  getPartnerOffers,
  partnerOffersQueryKey,
} from "@/services/api/marketplace";
import { useI18nStore } from "@/stores/i18nStore";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft, Tag } from "lucide-react";
import React from "react";
import { Link, useParams } from "react-router-dom";

const PartnerOffersPage: React.FC = () => {
  const { id = "" } = useParams<{ id: string }>();
  const { t } = useI18nStore();
  const { data, isLoading } = useQuery({
    queryKey: partnerOffersQueryKey(id),
    queryFn: () => getPartnerOffers(id),
    enabled: Boolean(id),
    retry: false,
  });

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageBanner
        icon={Tag}
        title={t.marketplaceTitle}
        description={t.marketplaceIntro}
      />
      <Link
        to={`/traveler/travels/${encodeURIComponent(id)}`}
        className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:underline"
      >
        <ArrowLeft className="h-4 w-4" />
        {t.marketplaceBackToTrip}
      </Link>
      {isLoading ? (
        <div className="h-24 animate-pulse rounded-xl bg-gray-100" />
      ) : data && data.length > 0 ? (
        <PartnerOfferList offers={data} tripId={id} />
      ) : (
        <p className="rounded-lg bg-gray-50 p-4 text-sm text-gray-600">
          {t.marketplaceEmpty}
        </p>
      )}
    </div>
  );
};

export default PartnerOffersPage;
